import Mustache from 'mustache'

import MESSAGES from 'core/data-model/constants/validation-messages'
import { createChecker } from 'core/service/lib/check'

import { validateTotalAllocationRule, validateMaxFundAllocationRule, validateMinFundAllocationRule } from './rules'

export const _validateInvestmentFundTotalAllocation = (displayProductQuery, getFunds) => async (
  totalFundAllocation,
  createValidationChecker = createChecker
) => {
  const totalAllocationSpec = {
    type: 'VALIDATION',
    rule: validateTotalAllocationRule,
    message: MESSAGES.RULE_IWEALTHY_TOTAL_FUND_LIMIT,
  }
  const investmentFundLimits = await getFunds(displayProductQuery)
  const validationChecker = createValidationChecker([['withinRpulFundLimitRange', totalAllocationSpec]])
  return validationChecker(investmentFundLimits, totalFundAllocation)
}

export const validateInvestmentFundTotalAllocation = (displayProductQuery, getFunds) => async (totalFundAllocation) =>
  _validateInvestmentFundTotalAllocation(displayProductQuery, getFunds)(totalFundAllocation)

export const _validateInvestmentFundAllocation = (displayProductQuery, getFunds) => async (
  fund,
  createValidationChecker = createChecker
) => {
  const fundMaxAllocationSpec = {
    type: 'VALIDATION',
    rule: validateMaxFundAllocationRule,
    message: MESSAGES.RULE_IWEALTHY_MAX_FUND_LIMIT,
  }
  const fundMinAllocationSpec = {
    type: 'VALIDATION',
    rule: validateMinFundAllocationRule,
    message: (investmentFundLimits, _) =>
      Mustache.render(MESSAGES.RULE_IWEALTHY_MIN_FUND_LIMIT, {
        minFundAllocation: investmentFundLimits.minFundAllocation,
      }),
  }
  const investmentFundLimits = await getFunds(displayProductQuery)
  const validationChecker = createValidationChecker([
    ['withinRpulMaxLimit', fundMaxAllocationSpec],
    ['withinRpulMinLimit', fundMinAllocationSpec],
  ])
  return validationChecker(investmentFundLimits, fund)
}

export const validateInvestmentFundAllocation = (displayProductQuery, getFunds) => async (fund) =>
  _validateInvestmentFundAllocation(displayProductQuery, getFunds)(fund)
